import { z } from "zod";

/** Query for `GET /v1/cede-arena/me/campaign-stake` — one competition, the authenticated viewer. */
export const ArenaMyCampaignStakeQuerySchema = z.object({
  campaign: z.string(),
});

export type ArenaMyCampaignStakeQueryDto = z.infer<typeof ArenaMyCampaignStakeQuerySchema>;

/**
 * What the viewer staked in one arena competition, and the ceiling on what they
 * can win from it (DEV-734).
 *
 * A free-entry ticket stakes nothing, so its holder is paid the ticket's face
 * value rather than the nominal pot — the UI must quote `maxWinUsdt`, not the
 * prize pool, or it advertises a figure the player cannot win.
 */
export const ArenaMyCampaignStakeSchema = z.object({
  /** TRUE ⇒ a free-entry ticket funded this seat. */
  fundedByTicket: z.boolean(),
  /** The viewer's payout ceiling (decimal USDT), or null when nothing caps them. */
  maxWinUsdt: z.string().nullable(),
});

export type ArenaMyCampaignStakeDto = z.infer<typeof ArenaMyCampaignStakeSchema>;
